var _Path, _Path2, _Path3, _Path4, _Path5, _Path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgHeartDisease = function SvgHeartDisease(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "heartDisease_svg__a",
    width: 56,
    height: 56,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    stroke: "#fff",
    strokeWidth: 0.8,
    d: "M.4.4h55.2v55.2H.4z"
  }))), /*#__PURE__*/React.createElement(G, {
    mask: "url(#heartDisease_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "m27.39 12.418.61.717.61-.717a13 13 0 0 1 4.454-3.41A12.7 12.7 0 0 1 38.5 7.8c3.456 0 6.301 1.15 8.593 3.44 2.29 2.292 3.44 5.137 3.44 8.593q0 .184-.013.367h-3.053v-.367c0-2.53-.853-4.683-2.568-6.399-1.715-1.715-3.868-2.567-6.4-2.567-1.988 0-3.832.563-5.516 1.679-1.513 1.002-2.626 2.27-3.306 3.804h-3.355c-.68-1.533-1.792-2.802-3.305-3.804-1.684-1.116-3.529-1.68-5.517-1.68-2.531 0-4.684.853-6.4 2.568-1.715 1.716-2.567 3.868-2.567 6.4v.366H5.48a5 5 0 0 1-.014-.367c0-3.456 1.15-6.301 3.441-8.592S14.044 7.8 17.5 7.8c1.905 0 3.714.402 5.436 1.208a13 13 0 0 1 4.454 3.41"
  }), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m27.39 12.418.61.717.61-.717a13 13 0 0 1 4.454-3.41A12.7 12.7 0 0 1 38.5 7.8c3.456 0 6.301 1.15 8.593 3.44 2.29 2.292 3.44 5.137 3.44 8.593q0 .184-.013.367h-3.053v-.367c0-2.53-.853-4.683-2.568-6.399-1.715-1.715-3.868-2.567-6.4-2.567-1.988 0-3.832.563-5.516 1.679-1.513 1.002-2.626 2.27-3.306 3.804h-3.355c-.68-1.533-1.792-2.802-3.305-3.804-1.684-1.116-3.529-1.68-5.517-1.68-2.531 0-4.684.853-6.4 2.568-1.715 1.716-2.567 3.868-2.567 6.4v.366H5.48a5 5 0 0 1-.014-.367c0-3.456 1.15-6.301 3.441-8.592S14.044 7.8 17.5 7.8c1.905 0 3.714.402 5.436 1.208a13 13 0 0 1 4.454 3.41"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M27.466 44.113a247 247 0 0 1-5.033-4.624 517 517 0 0 1-3.857-3.689H14.2a109 109 0 0 0 3.94 3.929 339 339 0 0 0 7.012 6.459l2.381-2.016z"
  }), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M27.466 44.113a247 247 0 0 1-5.033-4.624 517 517 0 0 1-3.857-3.689H14.2a109 109 0 0 0 3.94 3.929 339 339 0 0 0 7.012 6.459l2.381-2.016z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M37.424 35.8a517 517 0 0 1-3.857 3.69 247 247 0 0 1-5.033 4.622l-.534.479-.468-.42-2.381 2.017h5.698z"
  }), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M37.424 35.8a517 517 0 0 1-3.857 3.69 247 247 0 0 1-5.033 4.622l-.534.479-.468-.42-2.381 2.017h5.698z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M25.15 46.188 28 48.742l2.849-2.554z"
  }), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M25.15 46.188 28 48.742l2.849-2.554z"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.fillLine,
    d: "M41.857 35.8h-4.433l-6.575 10.388a409 409 0 0 0 7.044-6.462 103 103 0 0 0 3.964-3.926"
  }), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    fill: "#000",
    fillOpacity: 0.2,
    d: "M41.857 35.8h-4.433l-6.575 10.388a409 409 0 0 0 7.044-6.462 103 103 0 0 0 3.964-3.926"
  })), /*#__PURE__*/React.createElement(Path, {
    fill: props.accentFillLine,
    d: "M24.93 36.348a1.4 1.4 0 0 1-.581-.508l-4.266-6.307H3.133v-3.066h17.925c.25 0 .485.06.72.19.243.136.41.298.527.484l.006.01 2.897 4.346 3.668-11.002c.108-.326.282-.572.524-.763.217-.171.477-.265.817-.265.315 0 .596.063.853.185.234.111.426.275.58.508l4.267 6.307h16.95v3.066H35c-.249 0-.485-.06-.72-.19a1.4 1.4 0 0 1-.527-.484l-.007-.011-2.96-4.397-3.662 11.055a1.57 1.57 0 0 1-.524.762c-.217.172-.477.265-.817.265-.315 0-.596-.063-.853-.185"
  })));
};
export default SvgHeartDisease;